import wireframePlaceholderMenuIcon from '../assets/icons/wireframePlaceholderMenuIcon.svg';
import WireframeImage from './WireframeImage';

class WireframePlaceholder extends WireframeImage {
  constructor(fabricObject) {
    fabricObject.style ||= 'placeholder';
    super(fabricObject);
  }

  static iconSvg() {
    return wireframePlaceholderMenuIcon;
  }

  static externalName(): string {
    return 'Placeholder';
  }
}

export default WireframePlaceholder;
